import type * as NielsenBundle from '@foundation-player/plugin-nielsen';
import { PluginFactoryFunction } from '../builder-config';
import { PACKAGE_NAME_TO_GLOBAL_NAME, PackageName } from '../package-name';
import { resolveByPackageNameOrThrow } from '../resolve-bundle';

export const createNielsenPlugin: PluginFactoryFunction = (builderConfig) => {
  const nielsenPackage = PackageName.PluginNielsen;

  return [
    [nielsenPackage],
    () => {
      const nielsenGlobalName = PACKAGE_NAME_TO_GLOBAL_NAME[nielsenPackage];

      return [
        new (resolveByPackageNameOrThrow<typeof NielsenBundle>(nielsenPackage).NielsenPlugin)(
          builderConfig.pluginConfigs[nielsenGlobalName] as NielsenBundle.PluginConfig,
        ),
      ];
    },
  ];
};
